import { get, post, put, destroy } from '@/api/request';

function fetchCategories(params) {
  return get('/categories', params);
}

function createCategory(data) {
  return post('/categories', data);
}

function updateCategory({ id, data }) {
  return put(`/categories/${id}`, data);
}

function removeCategory(id) {
  return destroy(`/categories/${id}`);
}

function setDefaultCategory({ id }) {
  return put(`/categories/${id}/set_default`);
}

export default {
  fetchCategories,
  createCategory,
  updateCategory,
  removeCategory,
  setDefaultCategory,
};



// WEBPACK FOOTER //
// ./src/store/modules/category/api.js